/**
 * 模块说明 ：全局的逻辑函数
 */
import store from '@/store'
import { ElMessage } from 'element-plus'

export const useFun = () => {
  /**
   * 全局PDF跳转函数
   * @param type:string
   */
  const viewPDFPage = (type: string) => {
    const PDFObj = store.getters['moduleCommon/getCommonPDFObj']
    const url = PDFObj[type] || ''
    if (url) {
      window.open(url, '_blank')
    } else {
      ElMessage({
        message: '文件未提供！',
        type: 'warning'
      })
    }
  }

  /**
   * 查看上传资料函数
   * @params fileName 文件名
   * @params fileId 文件id
   *  */
  const handleImageUrl = (fileId: number | number, fileName: string) => {
    const res = `/tztapi/sysManager/previewFile?fileId=${fileId}&fileName=${fileName}`
    return res
  }

  /**
   *  校验邮箱号
   *  @params email 邮箱值
   */
  const modifyEmail = (email: string) => {
    const reg = /^([A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4})$/
    return reg.test(email.trim())
  }

  /**
   * 分页默认值
   * @params
   */
  const initPageData = (baseObj?: Partial<{ currentPage: number; pageSize: number; total: number }>) => {
    return Object.assign(
      {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      baseObj
    )
  }

  return {
    viewPDFPage,
    handleImageUrl,
    modifyEmail,
    initPageData
  }
}
